import type { IFormxRepository } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createDeleteFormxFieldUseCase({ formxRepository }: Deps) {
  return async function deleteFormxField(id: string): Promise<void> {
    return formxRepository.deleteField(id);
  };
}
